import type { FC } from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { getDeviationType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { useMainActionDeviationClick } from '../../../../hooks/useMainActionDeviationClick';
import DeviationSaleIndicators from '../DeviationSaleIndicators';

import s from './DeviationTitle.scss';

export interface Props {
  deviation: PapiDeviation;
  showSaleIndicators?: boolean;
}

const DeviationTitle: FC<Props> = ({ deviation, showSaleIndicators = true }) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLElement>(null);
  const { onClick } = useMainActionDeviationClick(deviation, containerRef, 'title');

  const deviationType = getDeviationType(deviation);
  const typeLabel = deviationType === DeviationTypes.FILM ? t('studio.table.type.film') : null;
  return (
    <PlainButtonOrLink
      className={s['root']}
      onClick={onClick}
      innerRef={el => (containerRef.current = el)}
    >
      {typeLabel && <div className={s['type']}>{typeLabel}</div>}
      <div className={s['title-wrapper']}>
        <div className={s['title']} title={deviation.title}>
          {deviation.title}
        </div>
        {showSaleIndicators && <DeviationSaleIndicators deviation={deviation} />}
      </div>
    </PlainButtonOrLink>
  );
};
DeviationTitle.displayName = 'DeviationTitle';

export default DeviationTitle;
